import ky from 'ky-universal';

import extendOrInitSession from './extendOrInitSession';
import getGeneralFields from './getGeneralFields';

import {
  TRACKING_EVENT__ONCLICK_PLACEMENT,
  TRACKING_OPERATION__CLICK,
  TRACKING_API_ENDPOINT,
} from '../../../constants';

/**
 * 傳送 onclick_placement 事件：
 * 先延長或建立新的 session，
 * 將 session ID 及 metadata 傳送到後端。
 *
 * @param {object} [op_meta]
 */
async function sendClickPlacementEvent(op_meta) {
  await extendOrInitSession();

  const payload = {
    ...getGeneralFields(),
    event: TRACKING_EVENT__ONCLICK_PLACEMENT,
    op: TRACKING_OPERATION__CLICK,
    op_meta,
  };

  await ky.post(TRACKING_API_ENDPOINT, { json: payload, throwHttpErrors: false });
}

import schedulePendingTasks from '../schedulePendingTasks';

export default (...args) => schedulePendingTasks(
  () => sendClickPlacementEvent(...args)
);
